const XIcon = ({ width = 36, height = 36, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    data-palette="XIcon">
    <rect width={width} height={height} fill="none" rx={18} />
    <path
      fill="currentColor"
      d="m18.984 15.31 4.097-4.81h1.785l-5.08 5.977L26 25.5h-5.673l-3.674-5.337-4.536 5.337h-1.815l5.544-6.506L10 10.5h5.673l3.311 4.81Zm2.068 8.703h2.202l-8.311-12.034h-2.2l8.31 12.034Z"
    />
  </svg>
);
export default XIcon;
